import React, { useState } from "react";
import {  InteractionModalContainer } from ".";
import { Row, Col } from "react-bootstrap";
import usePoolToken from "../../hooks/usePoolToken";
import InputAmount from "../InputAmount";
import InteractionButton from "../InteractionButton";
import BorrowAPR from "./TransactionRecap/BorrowAPR";
import BorrowFee from "./TransactionRecap/BorrowFee";
import useApprove from "../../hooks/useApprove";
import useBorrow from "../../hooks/useBorrow";
import { useToBigNumber } from "../../hooks/useConverter";
import RiskMetrics from "../RiskMetrics";
import FarmingAPR from "./TransactionRecap/FarmingAPR";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainAccountBorrowable } from "../../hooks/useOnchain";
import { ApprovalType, PoolTokenType } from "impermax-sdk";

/**
 * Props for the deposit interaction modal.
 * @property show Shows or hides the modal.
 * @property toggleShow A function to update the show variable to show or hide the Modal.
 */
export interface BorrowInteractionModalProps {
  show: boolean;
  toggleShow(s: boolean): void;
}

export default function BorrowInteractionModal({show, toggleShow}: BorrowInteractionModalProps) {
  const poolTokenType = usePoolToken();
  const [val, setVal] = useState<number>(0);

  const data = useGenericCall(useOnchainAccountBorrowable(), async onchainAccountBorrowable => ({
    symbol: await (await onchainAccountBorrowable.getPoolToken().getOffchainPoolToken()).getSymbol(),
    maxBorrowable: await onchainAccountBorrowable.getMaxBorrowable(),
  }));

  const amount = useToBigNumber(val);

  const invalidInput = data && val > data.maxBorrowable;
  const [approvalState, onApprove, permitData] = useApprove(ApprovalType.BORROW, amount, invalidInput);
  const [borrowState, borrow] = useBorrow(approvalState, amount, invalidInput, permitData);
  const onBorrow = async () => {
    await borrow();
    setVal(0);
    toggleShow(false);
  }

  if (!data) return (null);
  
  return (
    <InteractionModalContainer title="Borrow" show={show} toggleShow={toggleShow}><>
      <RiskMetrics
        changeBorrowedA={poolTokenType == PoolTokenType.BorrowableA ? val : 0}
        changeBorrowedB={poolTokenType == PoolTokenType.BorrowableB ? val : 0}
      />
      <InputAmount 
        val={val}
        setVal={setVal}
        suffix={data.symbol}
        maxTitle={'Available'}
        max={data.maxBorrowable}
      />
      <div className="transaction-recap">
        <BorrowFee amount={val} symbol={data.symbol} />
        <BorrowAPR amount={val} />
        <FarmingAPR amount={val} />
      </div>
      <Row className="interaction-row">
        <Col xs={6}>
          <InteractionButton name="Approve" onCall={onApprove} state={approvalState} />
        </Col>
        <Col xs={6}>
          <InteractionButton name="Borrow" onCall={onBorrow} state={borrowState} />
        </Col>
      </Row>
    </></InteractionModalContainer>
  );
}